import { useRef, useState } from 'react';
import { BootstrapDialog } from '../../../assets/style/globalStyle';
import PropTypes from 'prop-types';
import { NotificationManager } from 'react-notifications';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Iconify from '../../../@core/theme/Iconify';
import configAxios from '../../../services/configAxios';
import palette from 'src/@core/theme/palette';

export default function MoreMenuDocuments(props) {
  const URL_AWS_S3 = 'https://phormestablishments.s3.sa-east-1.amazonaws.com';

  const infosMoreMenuDocuments = props;
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleOpen = () => setModalIsOpen(true);
  const handleClose = () => setModalIsOpen(false);

  function handleViewFile(event) {
    const url = `${URL_AWS_S3}/${event.fileName}`;
    window.open(`${url}`, '_blank');
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  function deleteItem() {
    let router;

    router = `${infosMoreMenuDocuments.infos.deleteRouter}/${infosMoreMenuDocuments.infos.id}`;
    configAxios
      .delete(router)
      .then(() => {
        NotificationManager.success('Documento excluído com sucesso!', 'Sucesso');
        infosMoreMenuDocuments.infos.functionGrid();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para excluir o documento, tente novamente!',
          'Atenção'
        );
        if (!infosMoreMenuDocuments.infos.form) {
          infosMoreMenuDocuments.infos.functionGrid();
        }
      });
  }

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={modalIsOpen}>
          <BootstrapDialogTitle
            sx={{ color: palette.primary.contrastText }}
            id="customized-dialog-title"
            onClose={handleClose}>
            Confirmação de exclusão
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography
              sx={{ color: palette.primary.contrastText }}
              gutterBottom
              variant="subtitle2">
              Deseja realmente excluir o documento selecionado?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={deleteItem}
              color="success"
              variant="contained"
              startIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}>
              Sim
            </Button>
            <Button
              onClick={handleClose}
              color="error"
              variant="contained"
              startIcon={<Iconify icon="eva:close-circle-fill" />}>
              Não
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </div>

      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" id="iconEdit" width={20} height={20} />
      </IconButton>
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <MenuItem
          onClick={() => {
            handleViewFile(infosMoreMenuDocuments.infos);
            setIsOpen(false);
          }}
          sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify
              icon={
                infosMoreMenuDocuments.infos.form ? 'eva:cloud-download-outline' : 'eva:eye-outline'
              }
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText
            sx={{ color: palette.primary.contrastText }}
            primary={infosMoreMenuDocuments.infos.form ? 'Download' : 'Visualizar'}
            id="btnEdit"
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>

        <MenuItem
          sx={{ color: 'text.secondary' }}
          onClick={() => {
            handleOpen();
            setIsOpen(false);
          }}>
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Deletar"
            id="btnDelete"
            sx={{ color: palette.primary.contrastText }}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}
